import { render, staticRenderFns } from "./CouponSidebar.vue?vue&type=template&id=00bdb585&scoped=true&"
import script from "./CouponSidebar.vue?vue&type=script&lang=js&"
export * from "./CouponSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CouponSidebar.vue?vue&type=style&index=0&id=00bdb585&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bdb585",
  null
  
)

export default component.exports